<template>
   <div class='activities'>
      <process-header :step="5"/>
      <div class="body">
         <div class='step-title'>Develop Activities</div>
         <div class='goals'>
            <div class='goal' v-for="goal in goals" :key="goal.id">
               <div class="goal-name-wrapper">
                  Goal {{ goal.id }}: {{ goal.name }}
                  <el-button
                     @click="showCreateForm({goal_type: goal.id, table: table.objective})"
                     size="mini"
                     icon="el-icon-plus"
                     circle
                     content="Add Objective"
                     v-tippy
                  />
               </div>
               <div class="objectives" v-if="goal.objectives.length">
                  <div class="objective" v-for="(objective) in goal.objectives" :key="objective.id">
                     <div class="objective-head">
                        <div>
                           <div>Objective {{ objective.order }}: {{ objective.description }}</div>
                           <div style="font-weight: normal; font-size: 0.9em;">Strategy: {{ objective.strategy && objective.strategy.description }}</div>
                        </div>
                        <div class='action-btns'>
                           <el-button
                              size="mini"
                              @click="showCreateForm({objective: objective.id, table: table.activity})"
                              icon="el-icon-plus"
                              content="Add activity"
                              v-tippy
                              circle
                           />
                           <el-button
                              @click="handleEdit(objective, {table: table.objective})"
                              size="mini"
                              icon="el-icon-edit"
                              circle
                              content="Edit Objective"
                              v-tippy
                           />
                           <el-button
                              @click="handleDelete(objective, {table: table.objective})"
                              size="mini"
                              icon="el-icon-delete"
                              content="Delete Objective"
                              v-tippy
                              circle
                           />
                        </div>
                     </div>
                     <el-table :data="objective.activities">
                        <el-table-column label="Actions" fixed="right" width="100">
                           <template slot-scope="scope">
                              <el-button
                                 @click="handleEdit(scope.row, {table: table.activity})"
                                 size="mini"
                                 icon="el-icon-edit"
                                 style="margin-right: 2px;"
                                 circle
                                 content="Edit"
                                 v-tippy
                              />
                              <el-button
                                 @click="handleDelete(scope.row, {table: table.activity})"
                                 size="mini"
                                 icon="el-icon-delete"
                                 content="Delete"
                                 v-tippy
                                 circle
                              />
                           </template>
                        </el-table-column>
                        <el-table-column
                           v-for="{label, prop, width} in activityColumns"
                           :key="prop"
                           :prop="prop"
                           :width="width"
                           :label="label"
                        />
                     </el-table>
                  </div>
               </div>
               <div class='no-objectives' v-else>
                  No objectives under {{ goal.name.toLowerCase() }}
               </div>
            </div>
         </div>
         <back-and-continue
            :back-route="{name: 'opp-and-challenges'}"
            :next-route="{name: 'priority-assessment'}"
         />
      </div>
      <common-dialog-form
         :visible="showForm"
         :title="`${form.method==='post' ? 'Add new' : 'Edit'} ${currTable && currTable.toLowerCase()}`"
         @close="showForm=false"
         @submit="handleFormSubmit"
         >
         <input-field
            :label="currTable"
            type="text"
            v-model="form.description"
            :errors="errors.description"
            required
         />
         <template v-if="currTable===table.objective">
            <input-field
               label="Strategy"
               type="text"
               v-model="form.strategy.description"
               :errors="errors.strategy.description"
               required
            />
         </template>
         <template v-if="currTable===table.activity">
            <input-field
               label="Estimated Budget"
               type="number"
               :extra-attibutes="{ min: 0, step: 0.01 }"
               v-model="form.estimated_budget"
               :errors="errors.estimated_budget"
               required
            />
         </template>
      </common-dialog-form>
   </div>
</template>

<script>
import ProcessHeader from "../Header";
import { Table, TableColumn, Button } from 'element-ui';
import BackAndContinue from '@/components/molecules/Home/Plan/Back&Continue';
import CommonDialogForm from '../../../../organisms/Home/CommonDialogForm';
import InputField from '../../../../molecules/Login/InputField';
import { fetchWithAuthToken,postWithAuthToken } from '../../../../../axios';
import { getDefaultErrors } from '../../../../../js/form-helpers';
import { showError, showSuccess, showLoading, hideLoading,confirm, formatNumberNepaliStyle } from '../../../../../js/ui-helpers';

export default {
   name: "activities",
   components: {
      ProcessHeader,
      'el-table': Table,
      'el-table-column': TableColumn,
      'el-button': Button,
      BackAndContinue,
      InputField,
      CommonDialogForm,
   },
   data()
   {
      const table = {
         objective: "Objective",
         activity: "Activity",
      };
      const form = {
         id: null,
         goal_type: null,
         plan: this.planId,
         strategy: { description: "" },
         description: null,
         table: table.objective,
      };
      return {
         table,
         activityColumns: [
            { prop: 'code', label: 'Code' },
            { prop: 'description',      label: 'Activities' },
            { prop: 'estimated_budget', label: 'Estimated Budget', formatter: (row) => formatNumberNepaliStyle(row.estimated_budget) },
         ],
         form,
         currTable: null,
         errors: getDefaultErrors(form),
         goals: [],
         showForm: false,
      };
   },
   computed: {
      planId()
      {
         return this.$route.params.id;
      },
   },
   async created()
   {
      this.loadData();
   },
   methods: {
      loadData() {
         fetchWithAuthToken(`api/plan/${this.planId}/goals/`)
         .then(({data}) => this.goals = data);
      },
      getApiUrl({method, table, id})
      {
         if (table===this.table.activity)
            return `api/plan/${this.planId}/activities/${method==='post' ? '' : id}`;
         if (table===this.table.objective)
            return `api/plan/${this.planId}/objectives/${method==='post' ? '' : id}`;
      },
      getDefaultData(type, data={})
      {
         switch (type)
         {
            case this.table.activity:
               return {
                  id: null,
                  objective: null,
                  description: null,
                  method: 'post',
                  table: type,
                  estimated_budget: 0,
                  ...data
               };
            case this.table.objective:
               return {
                  id: null,
                  goal_type: null,
                  plan: this.planId,
                  strategy: { description: "" },
                  description: null,
                  method: 'post',
                  table: type,
                  ...data
               };
            default:
               return {
                  description: null,
               }
         }
      },
      resetErrors()
      {
         this.errors = getDefaultErrors(this.form);
      },
      showCreateForm(extraInfos)
      {
         this.currTable = extraInfos.table;
         this.form = this.getDefaultData(extraInfos.table, {method: 'post', ...extraInfos});
         this.errors = getDefaultErrors(this.form);
         console.log(this.form);
         this.showForm = true;
      },
      handleEdit(row, extraInfos)
      {
         this.currTable = extraInfos.table;
         this.form = this.getDefaultData(extraInfos.table, {method: 'put', ...extraInfos, ...row});
         this.errors = getDefaultErrors(this.form);
         this.showForm = true;
      },
      handleDelete(row, extraInfos)
      {
         this.currTable = extraInfos.table;
         confirm({
            title: `Delete ${this.currTable}`,
            msg: `Are you sure you want to delete this ${this.currTable.toLowerCase()}?`,
            onSuccess: () =>
            {
               const apiUrl = this.getApiUrl({method: 'delete', table: extraInfos.table, id: row.id});
               showLoading();
               postWithAuthToken(apiUrl, {}, {method: 'delete'})
               .then(() =>
               {
                  this.loadData();
                  showSuccess(this.currTable, `Successfully deleted`);
               })
               .catch(() =>
               {
                  showError(this.currTable, `Failed deleting`);
               })
               .finally(() => hideLoading());
            },
         });
      },
      handleFormSubmit()
      {
         const {method} = this.form;
         const apiUrl = this.getApiUrl(this.form);
         this.resetErrors();
         showLoading();
         postWithAuthToken(apiUrl, this.form, {method})
         .then(() =>
         {
            this.loadData();
            showSuccess(this.currTable, `Successfully ${method==='post' ? 'added' : 'edited'} ${this.currTable.toLowerCase()}`);
         })
         .catch(() =>
         {
            showError(this.currTable, `Failed ${method==='post' ? 'adding' : 'editing'} ${this.currTable.toLowerCase()}`);
         })
         .finally(() =>
         {
            this.form = this.getDefaultData(this.currTable);
            this.errors = getDefaultErrors(this.form);
            this.showForm = false;
            hideLoading();
         });
      }
   },
};
</script>

<style lang="scss" scoped>
.activities {
   font-family: $primary-font;
   color: $font-color;
   .step-title {
      font-family: $secondary-font;
      font-weight: 500;
      font-size: 1.05em;
      margin-bottom: 0.5em;
   }
   > .body {
      padding: 0.6em;
   }
   .add-button-wrapper {
      width: 100%;
      padding: 0.5em;
      > * {
         margin-left: auto;
      }
   }

   .goals {
      .goal {
         border-radius: 5px;
         overflow: hidden;
         margin-top: 0.5em;
         padding: 0.5em;
         background: $secondary-bg;
         .goal-name-wrapper {
            display: flex;
            justify-content: space-between;
            font-weight: 600;
            align-items: center;
            padding: 5px 8px;
         }

         .objectives {
            .objective {
               border-radius: 5px;
               overflow: hidden;
               width: 100%;
               border: 0.6px solid lightgrey;
               margin-bottom: 5px;
               .objective-head {
                  background: rgba(white, 0.5);
                  padding: 0.5em;
                  font-weight: 600;
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                  .action-btns {
                     display: flex;
                  }
               }
            }
         }
         .no-objectives {
            padding: 0.5em;
            background: rgba(white, 0.5);
         }
      }
   }

   .btn-group {
      display: flex;
      margin: 0 0.3em;
      > * {
         margin-right: 0.3em;
         a {
            color:inherit;
         }
         &:last-child {
            margin-right: 0;
         }
      }
   }
}
</style>
